import { putApiGalaxyServer } from 'services';
import { TeamMembershipType } from 'types';

export interface UpdateAccountAttributesPayload {
  is_csm: boolean;
  account_id: TeamMembershipType['account_id'];
}

export type UpdateAccountAttributesSuccessResponse = Record<string, never>;

export interface UpdateAccountAttributesErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const updateAccountAttributes = ({
  params: data,
  token,
  config = {},
}: BaseApiParams<UpdateAccountAttributesPayload>) =>
  putApiGalaxyServer(`/rails_api/galaxy/update_account_attributes`, data, config, token);
